var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{class:_vm.embeddedYoutubeLink ? 'open' : '',attrs:{"id":"youtube-player","title":"Exam answer youtube player","frameborder":"0","allowfullscreen":"allowfullscreen","width":"640","src":_vm.embeddedYoutubeLink}})}
var staticRenderFns = []

export { render, staticRenderFns }